import styled from "@emotion/styled";
import { Chip as MuiChip, type ChipProps } from "@mui/material";

import { shade } from "@skilitics/designer-theme";

import { FONT_WEIGHT_SEMI_BOLD, transientOptions } from "../utilities";

export type AnalyticsChipProps = ChipProps & {
  $chipColor?: string;
  $labelColor?: string;
  $iconPlacement?: "left" | "right";
};

const Chip = styled(MuiChip, transientOptions)<AnalyticsChipProps>`
  flex-direction: ${({ $iconPlacement = "left" }) => ($iconPlacement === "left" ? "row" : "row-reverse")};

  height: 14px;

  font-size: ${({ theme }) => theme.fontSizeSmall};
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};

  color: ${({ $labelColor, theme }) => $labelColor ?? theme.onNeutral};
  background-color: ${({ $chipColor, theme }) => $chipColor ?? theme.neutral};

  :hover {
    background-color: ${({ $chipColor, clickable, theme }) => shade($chipColor ?? theme.neutral, clickable ? 0.1 : 0)};
  }

  && > i {
    margin-right: ${({ $iconPlacement = "left" }) => ($iconPlacement === "left" ? -6 : 6)}px;
    margin-left: ${({ $iconPlacement = "left" }) => ($iconPlacement === "left" ? 5 : -5)}px;
  }

  > span {
    padding-right: 8px;
    padding-left: 8px;
  }
`;

export const AnalyticsChip = ({ clickable, ...props }: AnalyticsChipProps) => (
  <Chip {...props} clickable={clickable ?? true} />
);
